/*
 * hok-slideshow-app-guard.js
 * ---------------------------------------------------------------------------
 * Pre-order / collection-badge Shopify apps scan the page for links pointing at
 * /products/... and paint a full-bleed lime badge over any slideshow hero whose
 * CTA links to a product (slides 2+). Pure CSS keeps regressing because it has to
 * hard-code the app's class names; when the app renames or re-injects, the green
 * comes back (see CHANGELOG 0.3.x "Homepage slideshow slides 3-5 hero art hidden"
 * and "hero images on slides 2+").
 *
 * This guard neutralises the injection by SUBSTRING match instead of exact class
 * names, so it survives the app changing its markup. It does not touch how slides
 * are authored — the slideshow stays fully Theme-Editor configurable.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  // App-injected overlay nodes live inside the media wrapper. Our own theme never
  // adds nodes whose class contains "preorder" or "collection-badge", so any match
  // here is the app's and safe to remove.
  var INJECTED_NODE = '.slideshow__media [class*="preorder"], .slideshow__media [class*="collection-badge"]';

  // App also stamps layout-breaking classes onto the media element itself.
  var INJECTED_CLASS_RE = /(?:^|\s)(?:preorder-container-\S+|collection-badge-container)(?=\s|$)/g;

  function clean(root) {
    var nodes = root.querySelectorAll(INJECTED_NODE);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].remove();
    }

    var media = root.querySelectorAll('.slideshow__media.banner__media');
    for (var j = 0; j < media.length; j++) {
      var el = media[j];
      if (INJECTED_CLASS_RE.test(el.className)) {
        INJECTED_CLASS_RE.lastIndex = 0;
        el.className = el.className.replace(INJECTED_CLASS_RE, ' ').replace(/\s+/g, ' ').trim();
      }
      INJECTED_CLASS_RE.lastIndex = 0;
    }
  }

  function init(slideshow) {
    clean(slideshow);

    var scheduled = false;
    var observer = new MutationObserver(function () {
      // clean() is idempotent, so its own DOM edits settle within a frame without
      // looping; rAF batches bursty app injection into one pass.
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        clean(slideshow);
      });
    });

    observer.observe(slideshow, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function boot() {
    var slideshows = document.querySelectorAll('slideshow-component');
    for (var i = 0; i < slideshows.length; i++) {
      init(slideshows[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
